import React from 'react';

import { LogIn } from './LogIn';
import { ActivateNewUser } from './ActivateNewUser';
import { ResetPassword } from './ResetPassword';
import { UserActivation } from './UserActivation';
import { ActivateWorkspacePublic } from './ActivateWorkspace';
import { ReportScheduleExceptionPublic } from './ReportScheduleException';

export const PUBLIC_ROUTES = [
  {
    path: '/login',
    element: <LogIn />,
  },
  {
    path: '/reset-password/:token',
    element: <ResetPassword />,
    exact: true,
  },
  {
    path: '/accept-workspace/:token',
    element: <ActivateWorkspacePublic />,
  },
  {
    path: '/token-expired',
    element: <ReportScheduleExceptionPublic />,
  },
  {
    path: '/activate-user/:token',
    element: <UserActivation />,
    exact: true,
  },
  {
    path: '/activate-new-user/:token',
    element: <ActivateNewUser />,
    exact: true,
  },
];
